import { ReferralUsersResponseModel } from './../../../core/model/api-response/profile-response-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from 'src/app/global-variables';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService
  ) {}

  getReferralUsers(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<ReferralUsersResponseModel>(baseUrl + 'api/v2/referral', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ referralUsers: result.users })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getReferralUsers();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
}
